<template>
    <menu-layout :loading="loading">
        <row v-if="selected_task">
            <col8>
                <autocomplete :value="selected_task" @select="select_task" :options="tasks"></autocomplete>
            </col8>
            <col4 v-if="progress" data-testid="task-progress-left">
                {{progress}} left
            </col4>
        </row>
        <crop-task-view
            v-if="initiated && isCropTask"
            :filters="filters"
            @update_progress="update_progress"
        ></crop-task-view>
        <annotate
            v-else-if="initiated"
            :processing_tasks="true"
            :filters="filters"
            @update_progress="update_progress"
        ></annotate>
    </menu-layout>
</template>

<script>
  import MenuLayout from "@/components/layout/MenuLayout";
  import Annotate from "@/pages/Annotate";
  import CropTaskView from "@/components/tasks/CropTaskView";
  import Row from "@/components/layout/Row";
  import Col8 from "@/components/layout/Col8";
  import Col4 from "@/components/layout/Col4";
  import Autocomplete from "@/components/Autocomplete";
  import { isCropAnnotateType, parseTaskFilters } from "@/utils/cropTask";
  export default {
    data () {
      return {
        'loading': false,
        'filters': false,
        'initiated': false,
        'progress': false,
        'selected_task': false,
        'tasks': []
      }
    },
    computed: {
      isCropTask() {
        return this.selected_task && isCropAnnotateType(this.selected_task.annotate_type);
      }
    },
    mounted() {
      this.initiate()
    },
    methods: {
      async initiate() {
        this.loading = true
        const response = await this.$api.user_task.all_for_user()
        let tasks = Array.isArray(response) ? response : []

        tasks = [...tasks].sort((a, b) => (a.name > b.name) ? 1 : -1)

        this.tasks = tasks

        for (const task of tasks) {
          if(!await this.task_completed(task)) {
            this.filters = task.filter
            this.selected_task = task
            break
          }
        }
        
        this.initiated = true
        this.loading = false
      },
      async task_completed (task) {
        if (isCropAnnotateType(task.annotate_type)) {
          const filters = parseTaskFilters(task.filter);
          let result = await this.$api.annotation.filter(filters, 1);
          const items = (result && result.items) || [];
          return items.length === 0;
        }
        let result = await this.$api.asset.next_asset(task.filter);
        if(result.done === true) {
          return true
        }
        return false
      },
      select_task (task) {
        if(task) {
          this.filters = task.filter
          this.selected_task = task
        }
      },
      update_progress (progress) {
        if(progress == 0) {
          this.initiate();
        }
        this.progress = progress
      }
    },
    mixins: [],
    name: "Tasks",
    components: {Autocomplete, Col4, Col8, Row, Annotate, CropTaskView, MenuLayout}
  }
</script>

<style scoped>

</style>
